var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "list-responsavel" },
    _vm._l(_vm.assinadores, function(assinador) {
      return _c(
        "div",
        [
          _c("span", [
            _vm._v(
              _vm._s(assinador.responsavel.usuario.pessoa.pessoaFisica.nome)
            )
          ]),
          _vm.showIcon
            ? _c(
                "el-tooltip",
                {
                  attrs: {
                    content: assinador.assinado
                      ? "Assinado"
                      : "Aguardando assinatura",
                    placement: "top"
                  }
                },
                [
                  _c("i", {
                    class: assinador.assinado
                      ? "far fa-check-circle success"
                      : "far fa-clock"
                  })
                ]
              )
            : _vm._e()
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bdf2e872", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdf2e872","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/assinatura/components/ListResponsavelAssinatura.vue
// module id = null
// module chunks = 